window.tasksModule.directive "tInformation", ['$log', ($log) ->
  restrict: "E"
  scope:
    task: '='
  link: (scope, element, attrs) ->
    scope.$log = $log.getInstance('tInformation directive', true, false, true)
    scope.$log.log 'tInformation'

  templateUrl: 'portal/tasks/tasks/t-information/t-information-directive-template.html'
]